import RouteTemplate from 'ember-route-template'
import ErrorsNoStudentsPage from 'teacher-ui-client/components/errors/no-students-page'

export default RouteTemplate(ErrorsNoStudentsPage)
